import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6 offset-sm-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("span", { class: "badge text-dark" }, "Logging out...")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "unprotected"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("span", { class: "badge bg-warning" }, "Logout failed...")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.errors)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}